app.controller("OnlineOfferSearchController",
	["$scope", "$filter", "$timeout", "OnlineOfferSearchModel", "OnlineOfferSearchService", "BrowserStorageService", function($scope, $filter, $timeout, OnlineOfferSearchModel, OnlineOfferSearchService, BrowserStorageService) {


		$scope.query = OnlineOfferSearchModel.queries[$scope.searchID];

		$scope.priceRange = OnlineOfferSearchService.priceRange;
		$scope.searchID = undefined;
		$scope.SearchService = OnlineOfferSearchService;

		var addressTypes = {
			district: "kaupunginosa",
			municipality: "kunta",
			city: "kaupunki"
		};

		// Notes:
		// ApartmentSearchModelissa on hintasliderin min ja max-arvot, käytetäänkö samoja arvoja täällä vai
		// asetetaanko tarjouskauppaan oma skaala?

		// TODO
		function BuildNewQueryFromSearchParams() {
			OnlineOfferSearchModel.queries[$scope.searchID] = OnlineOfferSearchService.CreateQuery();
			$scope.query = OnlineOfferSearchModel.queries[$scope.searchID];
			$scope.query.SetResultLimit($scope.resultCount);
			for(var p in $scope.searchParams) {
				if($scope.searchParams.hasOwnProperty(p)) {
					switch(p) {
						case 'municipality':
							var addr = {
								type: 'municipality',
								value: $scope.searchParams.municipality,
								query: {
									municipality: $scope.searchParams.municipality
								},
								parsedValue: $scope.searchParams.municipality + ', ' + addressTypes['municipality']
							};
							if ($scope.searchParams.district) {
								addr.type = 'district';
								addr.value = $scope.searchParams.district + ', ' + $scope.searchParams.municipality;
								addr.query = {
									district: $scope.searchParams.district,
									municipality: $scope.searchParams.municipality
								};
								addr.parsedValue = $scope.searchParams.district + ', ' + $scope.searchParams.municipality + ', ' + addressTypes['district'];
							}
							OnlineOfferSearchModel.queries[$scope.searchID].AddAddressConstraint(addr);
							break;
					}
				}

			}

		}

		$scope.InitQuery = function(searchID, resultCount) {

			$scope.searchID = searchID;
			$scope.resultCount = resultCount;
			// searchParams should be set from Twig, if there are any given.
			if(typeof($scope.searchParams) == 'object' && $scope.searchParams != null && !Array.isArray($scope.searchParams)) {
				BuildNewQueryFromSearchParams();
			}
			else {
				var queryBlob = BrowserStorageService.LocalStorage.GetItem("OnlineOfferSearchQuery");
				if(OnlineOfferSearchModel.queries[$scope.searchID] === undefined) {
					OnlineOfferSearchModel.queries[$scope.searchID] = OnlineOfferSearchService.CreateQuery();
					OnlineOfferSearchModel.queries[$scope.searchID].SetResultLimit($scope.resultCount);
					$scope.query = OnlineOfferSearchModel.queries[$scope.searchID];
				}


				if(queryBlob != null && queryBlob.queryVersion == $scope.query.GetQueryVersion()) {
					$scope.query.MergeStorageQueryBlob(queryBlob);
					$scope.query.SetResultLimit($scope.resultCount);
				}
				else {
					BrowserStorageService.LocalStorage.SetItem("OnlineOfferSearchQuery", $scope.query.GetAsStorageBlob());
				}
			}

			// Vasta seuraavassa digest-cyclessä, jotta notificationListenerit ehtii rekisteröityä turvallisesti hierarkiasta riippumatta.
			$timeout(function() {
				OnlineOfferSearchService.SendNotificationToListeners("OnlineOfferSearchBarReady", {
					searchID: $scope.searchID,
					query: OnlineOfferSearchModel.queries[$scope.searchID]
				});
			});
		};


		$scope.onQueryRun = function() {
			console.log("Query was run.");
			console.log(OnlineOfferSearchService.results[$scope.searchID]);
		};

		$scope.GetPriceSliderText = function() {
			var min = $filter('currency')($scope.query.GetPriceConstraints().min, ' ', ' ', ' ', 0);
			var max;

			var priceConstraints = $scope.query.GetPriceConstraints();
			if(priceConstraints.min == OnlineOfferSearchService.priceRange.ceil ||
				priceConstraints.max == OnlineOfferSearchService.priceRange.ceil) {
				var price = $filter('currency')(OnlineOfferSearchService.priceRange.actualceil, ' ', ' ', ' ', 0);
				max = (price + '+');
			}
			else {
				max = $filter('currency')($scope.query.GetPriceConstraints().max, ' ', ' ', ' ', 0);
			}

			return min + " - " + max;
		};

		$scope.SubmitQuery = function() {
			var queryBlob = $scope.query.GetAsStorageBlob();
			BrowserStorageService.LocalStorage.SetItem("OnlineOfferSearchQuery", queryBlob);
			OnlineOfferSearchService.RunQuery($scope.query, $scope.searchID, false, $scope.onQueryRun, false);
		};
	}]

);